<template>
  <ul class="nav nav-pills flex-column m-o p-3" :aria-label="ariaLabel">
    <template v-for="(section, sectionIndex) in sections" :key="`section-${sectionIndex}`">
      <li v-if="section.title" class="nav-item app-sidebar-section-title">
        <span>{{ section.title }}</span>
      </li>
      <li
        v-for="item in section.items || []"
        :key="`${section.title || 'section'}-${item.label}`"
        class="nav-item"
      >
        <a
          :href="item.href"
          class="nav-link"
          :class="{ active: !!item.active }"
          :target="item.external ? '_blank' : null"
          :rel="item.external ? 'noopener noreferrer' : null"
        >
          {{ item.label }}
        </a>
      </li>
    </template>
  </ul>
</template>

<script setup>
defineProps({
  ariaLabel: {
    type: String,
    default: "Sidebar menu"
  },
  sections: {
    type: Array,
    default: () => []
  }
})
</script>
